export type Language = 'ru' | 'zh';

export interface TrackingStatus {
  status: string;
  updated_at: string;
  tracking_number: string;
}

export interface OrderTracking {
  tracking_number: string;
  order_id: string;
  status_date: string;
}

export type ErrorLogType = 'API' | 'DATABASE' | 'CAMERA' | 'SCAN' | 'VALIDATION';

export interface ScanResult {
  tracking_numbers: string;
  timestamp: number;
  format: string;
  isDuplicate?: boolean;
}

export interface AppState {
  language: Language;
  history: ScanResult[];
  setLanguage: (lang: Language) => void;
  addScan: (scan: ScanResult) => { success: boolean; message: string };
  removeScan: (timestamp: number) => void;
  deleteScan: (timestamp: number) => Promise<{ success: boolean; message: string }>;
  clearHistory: () => Promise<{ success: boolean; message: string }>;
  syncHistory: () => Promise<void>;
  createTables: () => Promise<{ success: boolean; error?: string }>;
}

export interface ScanResponse {
  success: boolean;
  message: string;
  data?: any;
}

export const translations = {
  ru: {
    duplicateTitle: 'Дубликат трек-номера',
    duplicateMessage: 'Данный трек-номер уже существует в базе данных',
    shipmentHistory: 'История отправлений',
    history: 'История',
    allStatuses: 'Все статусы',
    duplicateTitle: 'Дубликат трек-номера',
    duplicateMessage: 'Данный трек-номер уже существует в базе данных',
    sent: 'Отправлен',
    nothingFound: 'Ничего не найдено',
    noShipments: 'Нет отправлений',
    status: 'Статус',
    dates: 'Даты',
    created: 'Создано',
    updated: 'Обновлено',
    boxes: 'Коробки',
    box: 'Коробка',
    saving: 'Сохранение...',
    save: 'Сохранить',
    edit: 'Редактировать',
    weight: 'Вес',
    volume: 'Объем',
    width: 'Ширина',
    height: 'Высота',
    depth: 'Глубина',
    totals: 'Итого',
    totalWeight: 'Общий вес',
    totalVolume: 'Общий объем',
    trackingNumbers: 'Трек номера',
    density: 'Плотность',
    confirmScan: 'Подтвердите сканирование',
    format: 'Формат',
    cancel: 'Отменить',
    confirm: 'Подтвердить',
    saving: 'Сохранение...',
    trackingSaved: 'Трек-номер сохранен',
    scan: 'Сканировать',
    stop: 'Остановить',
    initializing: 'Инициализация...',
    manualInput: 'Ручной ввод',
    enterBarcode: 'Введите штрих-код',
    submit: 'Отправить',
    cancel: 'Отмена',
    scanInstructions: 'Наведите камеру на штрих-код',
    scanSuccess: 'Успешно отсканировано',
    scanError: 'Ошибка сканирования',
    resume: 'Продолжить',
    clickToResume: 'Нажмите "Продолжить" для следующего сканирования',
    invalidTrackingNumber: 'Неверный трек-номер',
    duplicate: 'Дубликат',
    loadError: 'Ошибка загрузки трек-номеров',
    cooldown: 'Подождите...',
    cameraError: 'Ошибка камеры',
    stopError: 'Ошибка остановки сканера',
    torchEnabled: 'Вспышка включена',
    torchDisabled: 'Вспышка выключена',
    torchError: 'Ошибка управления вспышкой',
    noHistory: 'История пуста',
    delete: 'Удалить',
    deleteConfirm: 'Удалить этот скан?',
    filter: 'Фильтр',
    searchPlaceholder: 'Поиск по трек-номеру...',
    allDates: 'Все даты',
    today: 'Сегодня',
    yesterday: 'Вчера',
    createShipment: 'Создать отправление',
    shipmentNumber: 'Номер отправления',
    trackingNumbers: 'Трек-номера',
    pieces: 'шт.',
    invalidShipmentNumber: 'Номер отправления должен быть в формате ЯР-XXXX-X, где после ЯР- идут ровно 4 цифры, дефис и от 1 до 3 цифр',
    boxes: 'Коробки',
    box: 'Коробка',
    addBox: 'Добавить коробку',
    weight: 'Вес',
    dimensions: 'Размеры',
    width: 'Ширина',
    height: 'Высота',
    depth: 'Глубина',
    volume: 'Объем',
    summary: 'Итого',
    shipmentNumberLabel: 'Номер отправления',
    trackingNumberCount: 'Количество трек-номеров',
    totalWeight: 'Общий вес',
    totalVolume: 'Общий объем',
    send: 'Отправить',
    thankYou: 'Спасибо за отличную работу!',
    shipmentCreated: 'Отправление успешно создано',
    scanner: 'Сканер',
    markedCount: 'Отмечено',
    of: 'из',
    lastMarked: 'Последний',
    enterComment: 'Введите комментарий...',
    addChildTracking: 'Добавить дочерний трек-номер...',
    childTrackings: 'Дочерние трек-номера',
    shipmentHistory: 'История отправлений',
    history: 'История',
    allStatuses: 'Все статусы',
    sent: 'Отправлен',
    nothingFound: 'Ничего не найдено',
    noShipments: 'Нет отправлений',
    status: 'Статус',
    dates: 'Даты',
    created: 'Создано',
    updated: 'Обновлено',
    boxes: 'Коробки',
    box: 'Коробка',
    saving: 'Сохранение...',
    save: 'Сохранить',
    edit: 'Редактировать',
    weight: 'Вес',
    volume: 'Объем',
    width: 'Ширина',
    height: 'Высота',
    depth: 'Глубина',
    totals: 'Итого',
    totalWeight: 'Общий вес',
    totalVolume: 'Общий объем',
    trackingNumbers: 'Трек номера',
    density: 'Плотность',
    receivedInChina: 'Получено в Китае',
    unmatchedScan: 'Нераспознанный скан'
  },
  zh: {
    duplicateTitle: '重复跟踪号',
    duplicateMessage: '此跟踪号已存在于数据库中',
    shipmentHistory: '发货历史',
    history: '历史',
    allStatuses: '所有状态',
    duplicateTitle: '重复跟踪号',
    duplicateMessage: '此跟踪号已存在于数据库中',
    sent: '已发送',
    nothingFound: '未找到结果',
    noShipments: '没有发货记录',
    status: '状态',
    dates: '日期',
    created: '创建时间',
    updated: '更新时间',
    boxes: '包装箱',
    box: '包装箱',
    saving: '保存中...',
    save: '保存',
    edit: '编辑',
    weight: '重量',
    volume: '体积',
    width: '宽度',
    height: '高度',
    depth: '深度',
    totals: '总计',
    totalWeight: '总重量',
    totalVolume: '总体积',
    trackingNumbers: '跟踪号',
    density: '密度',
    scan: '扫描',
    stop: '停止',
    initializing: '初始化中...',
    manualInput: '手动输入',
    enterBarcode: '输入条形码',
    submit: '提交',
    cancel: '取消',
    scanInstructions: '将相机对准条形码',
    scanSuccess: '扫描成功',
    scanError: '扫描错误',
    resume: '继续',
    clickToResume: '点击"继续"进行下一次扫描',
    invalidTrackingNumber: '无效的跟踪号',
    duplicate: '重复',
    loadError: '加载跟踪号时出错',
    cooldown: '请等待...',
    cameraError: '相机错误',
    stopError: '停止扫描器错误',
    torchEnabled: '闪光灯已开启',
    torchDisabled: '闪光灯已关闭',
    torchError: '闪光灯控制错误',
    noHistory: '历史记录为空',
    delete: '删除',
    deleteConfirm: '删除此扫描？',
    filter: '筛选',
    searchPlaceholder: '搜索跟踪号...',
    allDates: '所有日期',
    today: '今天',
    yesterday: '昨天',
    createShipment: '创建发货',
    shipmentNumber: '发货编号',
    trackingNumbers: '跟踪号',
    pieces: '件',
    invalidShipmentNumber: '发货编号必须采用 ЯР-XXXX-X 格式，其中 ЯР- 后必须是4位数字，连字符，然后是1-3位数字',
    boxes: '包装箱',
    box: '包装箱',
    addBox: '添加包装箱',
    weight: '重量',
    dimensions: '尺寸',
    width: '宽度',
    height: '高度',
    depth: '深度',
    volume: '体积',
    summary: '总计',
    shipmentNumberLabel: '发货编号',
    trackingNumberCount: '跟踪号数量',
    totalWeight: '总重量',
    totalVolume: '总体积',
    send: '发送',
    thankYou: '感谢您的出色工作！',
    shipmentCreated: '发货已成功创建',
    scanner: '扫描器',
    markedCount: '已标记',
    of: '/',
    lastMarked: '最后标记',
    enterComment: '输入评论...',
    addChildTracking: '添加子跟踪号...',
    childTrackings: '子跟踪号',
    shipmentHistory: '发货历史',
    history: '历史',
    allStatuses: '所有状态',
    sent: '已发送',
    nothingFound: '未找到结果',
    noShipments: '没有发货记录',
    status: '状态',
    dates: '日期',
    created: '创建时间',
    updated: '更新时间',
    boxes: '包装箱',
    box: '包装箱',
    saving: '保存中...',
    save: '保存',
    edit: '编辑',
    weight: '重量',
    volume: '体积',
    width: '宽度',
    height: '高度',
    depth: '深度',
    totals: '总计',
    totalWeight: '总重量',
    totalVolume: '总体积',
    trackingNumbers: '跟踪号',
    density: '密度',
    confirmScan: '确认扫描',
    format: '格式',
    cancel: '取消',
    confirm: '确认',
    saving: '保存中...',
    trackingSaved: '跟踪号已保存',
    receivedInChina: '已在中国收到',
    unmatchedScan: '未匹配扫描'
  }
} as const;